import React from 'react';
import { OfferHero } from './components/OfferHero';
import { ProblemSolution } from './components/ProblemSolution';
import { Modules } from './components/Modules';
import { Benefits } from './components/Benefits';
import { Trainers } from './components/Trainers';
import { ForWhom } from './components/ForWhom';
import { Pricing } from './components/Pricing';
import { OfferTestimonials } from './components/OfferTestimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/ui';
export function App() {
  return <div className="min-h-screen bg-navy text-textLight font-sans selection:bg-gold/30 selection:text-white" data-id="element-0">
      <OfferHero data-id="element-1" />
      <SectionDivider data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <SectionDivider data-id="element-4" />
      <Modules data-id="element-5" />
      <SectionDivider data-id="element-6" />
      <Benefits data-id="element-7" />
      <SectionDivider data-id="element-8" />
      <Trainers data-id="element-9" />
      <SectionDivider data-id="element-10" />
      <ForWhom data-id="element-11" />
      <SectionDivider data-id="element-12" />
      <Pricing data-id="element-13" />
      <OfferTestimonials data-id="element-14" />
      <SectionDivider data-id="element-15" />
      <FAQ data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}